import { Alert, Button, PagerBalls } from '@root/components'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FaArrowLeft, FaArrowRight, FaMinusCircle } from 'react-icons/fa'
import { Footer, FooterActions, FooterCenter, FooterSlot } from './CancelFlow.styled'
import { CancelFlowStep } from './types'

interface Props {
  currentStep: CancelFlowStep
  isCancellationOptionsStepValid: boolean
  isChurnReasonStepValid: boolean
  isSubmitting: boolean
  onBack: () => void
  onNext: () => void
  onCancelPlan: () => void
}

export const CancelFlowFooter: React.FC<Props> = ({
  currentStep,
  isCancellationOptionsStepValid,
  isChurnReasonStepValid,
  isSubmitting,
  onBack,
  onNext,
  onCancelPlan
}) => {
  const { t } = useTranslation()

  return (
    <Footer>
      <Alert isVisible type="warning" description={t('settings.billing.cancelNotice')} />
      <FooterActions>
        <FooterSlot>
          <Button
            intent="default"
            type="button"
            onClick={onBack}
            showSpinner={isSubmitting}
            icon={<FaArrowLeft />}
          >
            {t('general.back')}
          </Button>
        </FooterSlot>
        <FooterCenter>
          <PagerBalls slideIndex={currentStep === 'churn-reason' ? 1 : 0} slideCount={2} />
        </FooterCenter>
        <FooterSlot $alignRight>
          {currentStep === 'cancellation-options' ? (
            <Button
              intent="default"
              type="button"
              onClick={onNext}
              disabled={!isCancellationOptionsStepValid}
              iconRight={<FaArrowRight />}
            >
              {t('general.next')}
            </Button>
          ) : (
            <Button
              intent="danger"
              type="button"
              onClick={onCancelPlan}
              showSpinner={isSubmitting}
              icon={<FaMinusCircle />}
              disabled={!isChurnReasonStepValid || !isCancellationOptionsStepValid || isSubmitting}
            >
              {t('settings.billing.cancelSubscription')}
            </Button>
          )}
        </FooterSlot>
      </FooterActions>
    </Footer>
  )
}
